"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsStoreRecord = void 0;
const immutable_1 = require("immutable");
const core_1 = require("companion-app-components/flux/core");
exports.AccountsStoreRecord = (0, immutable_1.Record)(Object.assign(Object.assign({}, core_1.resourceStoreTypes.mkQcsSyncResourceStore({ resourceName: 'ACCOUNTS' }).toObject()), { isInvestmentAccountsLoading: false }));
